import React from 'react';
import PropTypes from 'prop-types';
import { hasPermission } from '@lib/permissions';
import TertiaryDropDown from './partials/TertiaryDropdown';
import TertiaryRoute from './partials/TertiaryRoute';
import { TertiaryOptionsContainer } from './TertiaryOptions.styles';

function filterBasedOnPermission(subMenu) {
  const allowedSubMenu = subMenu.filter((item) => {
    if (!item.reqPermission) return true;

    const permission = hasPermission(item.reqPermission);

    return permission;
  });

  return allowedSubMenu;
}

function TertiaryOptions(props) {
  const { options, routeName } = props;
  if (!options) return null;
  return (
    <TertiaryOptionsContainer>
      {options.map((option) => {
        const { subMenu, label, route, icon, routeMatches, reqPermission } = option;
        if (reqPermission && !hasPermission(reqPermission)) return null;
        if (subMenu && subMenu.length) {
          const allowedSubMenu = filterBasedOnPermission(subMenu);

          return (
            <TertiaryDropDown
              subMenu={allowedSubMenu}
              routeMatches={routeMatches}
              label={label}
              routeName={routeName}
              icon={icon}
            />
          );
        }
        return <TertiaryRoute label={label} route={route} routeName={routeName} />;
      })}
    </TertiaryOptionsContainer>
  );
}

TertiaryOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.string,
      label: PropTypes.shape({ defaultMessage: PropTypes.string })
    })
  ).isRequired,
  routeName: PropTypes.string.isRequired
};

export default TertiaryOptions;
